
export const getDomain = () => {
	const domain = 'https://api.oli.fyi/';

	return domain;
};